import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBlogAuth } from './blog-auth-context';

/**
 * O portão do /admin no portal — conveniência de UI: quem autoriza de verdade é
 * a Members API, a cada requisição (sem o papel, 404). Enquanto a sessão
 * resolve, nada; sem sessão, o /login lembrando o destino (como o RequireAuth);
 * logado sem o papel, o `notFound` que o router passa (a página 404 do portal),
 * para a área não se revelar.
 */
export function RequireAdmin({
  children,
  notFound,
}: {
  children: ReactNode;
  notFound: ReactNode;
}): JSX.Element | null {
  const { status, user } = useBlogAuth();
  const location = useLocation();

  if (status === 'loading') return null;

  if (status === 'unauthenticated' || !user) {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <>{user.isAdmin ? children : notFound}</>;
}
